import { ChatLink } from '../ChatLink';
import { BoldTextList } from './BoldText';
import { isNavigableRoute, useSiteMapFeatureAccess } from '@/machines/useAIPageContext';

const LINK_REGEX = /<a\s+href=['"]([^'"]*)['"]\s*>([^<]*)<\/a>/g;

interface LineContentProps {
    line: string;
    keyPrefix: string;
}

export const LineContent = ({ line, keyPrefix }: LineContentProps) => {
    const featureAccess = useSiteMapFeatureAccess();

    if (!line.includes('<a ')) {
        return <BoldTextList text={line} keyPrefix={keyPrefix} />;
    }

    const result: React.ReactNode[] = [];
    let lastIndex = 0;

    for (const match of line.matchAll(LINK_REGEX)) {
        const [fullMatch, href, linkText] = match;
        const matchIndex = match.index!;

        if (!isNavigableRoute(href.split('?')[0], featureAccess)) {
            if (matchIndex > lastIndex) {
                result.push(
                    <BoldTextList key={`bold-${keyPrefix}-${lastIndex}`} text={line.slice(lastIndex, matchIndex)} keyPrefix={`${keyPrefix}-${lastIndex}`} />,
                );
            }
            lastIndex = matchIndex + fullMatch.length;
            continue;
        }

        if (matchIndex > lastIndex) {
            result.push(
                <BoldTextList key={`bold-${keyPrefix}-${lastIndex}`} text={line.slice(lastIndex, matchIndex)} keyPrefix={`${keyPrefix}-${lastIndex}`} />,
            );
        }

        result.push(
            <ChatLink key={`link-${matchIndex}`} href={href}>
                {linkText}
            </ChatLink>,
        );

        lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < line.length) {
        result.push(
            <BoldTextList key={`bold-${keyPrefix}-${lastIndex}`} text={line.slice(lastIndex)} keyPrefix={`${keyPrefix}-${lastIndex}`} />,
        );
    }

    return result;
};
